import type { OnboardingView } from '@alterium/shared';
import { api } from './client';

/** Коридор первого входа (§6, §71). */
export const onboardingApi = {
  get: () => api.get<OnboardingView>('/onboarding'),
  /** Выйти в кабинет, не доводя до первого ролика. */
  skip: () => api.post<OnboardingView>('/onboarding/skip'),
};
